import createIcon from './createIcon';
import MenuFoldOutlinedSvg from './svg/menu-fold-outlined.svg?react';

const MenuFoldOutlinedIcon = createIcon(MenuFoldOutlinedSvg);

export default MenuFoldOutlinedIcon;
